export default "__VITE_PUBLIC_ASSET__1570a005__"